import React, { useContext, useEffect, useState } from "react";
import { ref, get, child, update } from "firebase/database";
import { db, rtdb } from "../@shared/firebase/config"; // make sure this is your initialized RTDB reference
import {
  Modal,
  Box,
  Typography,
  TextField,
  CircularProgress,
} from "@mui/material";
import NeoButton from "./NeoButton";
import { useRoomsStore } from "../@shared/store/useRoomsStore";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { MainContext } from "../App";
import Toast from "./Toast";
import confetti from "canvas-confetti";
import { updateDoc, doc } from "firebase/firestore";
import ModalComponent from "./ModalComponent";
import { HeaderActionButton } from "./ui";

const screenHeight = window.innerHeight;

const modalHeight = screenHeight * 0.6;
const modalWidth = modalHeight * (4 / 5);

const backgroundImage = require("../@shared/assets/game_menu.png");

const JoinPartyModal = ({ visible, onClose, userId }) => {
  const { userData } = useAuthStore();
  const [codeInput, setCodeInput] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { Theme, setError, setMessage, setPartyId, setIsHost } =
    useContext(MainContext);

  const handleCodeJoin = async () => {
    const accessCode = Number(codeInput);

    if (!accessCode) {
      setMessage("Please enter a valid 5-digit code.");
      setError(true);
      return;
    }
    setLoading(true);

    try {
      const snapshot = await get(ref(rtdb, `presence`));

      if (!snapshot.exists()) {
        setMessage("No players found.");
        setError(true);
        setLoading(false);
        return;
      }

      const allPlayers = snapshot.val();

      const partyExists = Object.values(allPlayers).some(
        (player) => player.partyId === accessCode && player.host === true
      );

      if (!partyExists) {
        setMessage("Party not found. Please check the code.");
        setError(true);
        setLoading(false);
        return;
      }

      // 🎉 Launch confetti
      confetti({
        particleCount: 150,
        angle: 90,
        spread: 180,
        startVelocity: 45,
        origin: { y: 0.5 },
        zIndex: 9999,
      });

      const handleAddToParty = async () => {
        const userDocRef = doc(db, "users", userData.id);
        await updateDoc(userDocRef, {
          partyId: accessCode,
          isHost: false,
        });
      };

      // Update the player's record
      setTimeout(() => {
        handleAddToParty();
      }, 2000);
      // Navigate or close modal
      onClose();
    } catch (err) {
      setMessage("Error joining party:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <ModalComponent
      aspectRatio={"5/7"}
      md={5}
      lg={3}
      modalOpen={visible}
      setModalOpen={handleClose}
    >
      <Toast onFinish={() => {}} timeTilClose={2000} />
      <Typography
        variant="h6"
        sx={{
          color: "#fff",
          fontWeight: "bold",
          mb: 2,
          textAlign: "center",
          padding: "10px",
          borderRadius: "5px",
          backgroundColor: "#00000080",
          width: "100%",
          height: "fit-content",
        }}
      >
        Join a Party
      </Typography>

      <Typography
        style={{
          color: "#fff",
          fontSize: "16px",
          width: "100%",
          textAlign: "center",
          margin: "10% 0",
        }}
      >
        Enter a 5-digit Party Code to join your friend’s world. Make sure the
        code is correct and that their world is active. Once joined, you'll be
        able to explore, battle, and hang out together.
      </Typography>

      <Box sx={styles.codeRow}>
        <TextField
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter 5-digit Party ID"
          value={codeInput}
          onChange={(e) => setCodeInput(e.target.value)}
          sx={{ flex: 1 }}
        />
        <HeaderActionButton label="Join" tone="gold" onClick={handleCodeJoin} />
      </Box>

    </ModalComponent>
  );
};

const styles = {
  modalContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
    height: { xs: "70%", md: "60%" },
    width: { xs: "95%", md: "30%" },
    position: "absolute",
    outline: "none",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  modalContentWrapper: {
    width: modalWidth,
    height: modalHeight,
  },
  modalContent: {
    width: modalWidth,
    height: modalHeight,
    paddingTop: "8%",
    paddingLeft: "8%",
    paddingRight: "8%",
    paddingBottom: "%",
    borderRadius: 16,
    elevation: 5,
    borderColor: "#fff",
    position: "relative",
  },
  codeRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    mb: 2,
  },
  scrollArea: {
    mt: 1,
    maxHeight: 300,
    overflowY: "auto",
  },
  roomRow: {
    backgroundColor: "#4e2a9b",
    p: 1,
    borderRadius: 1,
    mb: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  buttonRow: {
    mt: 2,
  },
};

export default JoinPartyModal;
